import styles from "./SingleSubProduct.module.css";
import ShoppingCartIcon from "../../assets/images/shopping_cart_icon.jpg";
import "../../fonts/Futura-PT-Book.ttf";
import { useState } from "react";
import useAxios from "../Hooks/useAxios";
import { useNavigate } from "react-router-dom";
const SingleSubProduct = ({
  title,
  productCode,
  price,
  cartValue,
  favorite,
  locked,
  data,
  open_popup,
  setCartChanged,
}) => {
  console.log(productCode, "test");
  const axios = useAxios();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [currentFavorite, setCurrentFavorite] = useState(favorite);
  const backend_base = process.env.REACT_APP_API_BASE_URL;

  const changeFavorite = () => {
    if (locked) return;
    console.log(data);
    axios
      .post(backend_base + "/shop/product/favorite", {
        product: data.id,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log(res.data);
          setCurrentFavorite(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const addToCart = () => {
    if (locked) {
      navigate("/cart-front");
      return;
    }
    if (count < 1) return;
    axios
      .post(backend_base + "/order/cart", {
        product: data.id,
        quantity: count,
        action: "+",
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          open_popup(true);
          setCartChanged(true);
        } else {
          setCount(0);
        }
      })
      .catch((e) => {
        console.log(e);
        setCount(0);
      });
  };

  return (
    <div className={styles.row}>
      <div className={`${styles.title_text} `}>
        {title}
        &nbsp;&nbsp;&nbsp;{" "}
        {new Intl.NumberFormat("ja-JP", {
          style: "currency",
          currency: "JPY",
        }).format(price)}
      </div>
      <div className={`${styles.second_sec} text-left`}>
        <div className={styles.button_sec_main}>
          <button
            onClick={() => {
              // if (locked) {
              //   navigate("/login");
              // } else
              if (count > 0) {
                setCount(count - 1);
              }
            }}
            className={`${styles.inc_dec_button0}`}
          >
            <div className={styles.dec_but}>_</div>
          </button>
          <button
            disabled
            className={`${styles.inc_dec_button2} ${styles.num_inc_border_left_remove}`}
          >
            {count}
          </button>
          <button
            onClick={() => {
              // if (locked) {
              //   navigate("/login");
              // } else {
              setCount(count + 1);
              // }
            }}
            className={`${styles.inc_dec_button} ${styles.num_inc_border_left_remove}`}
          >
            +
          </button>
        </div>
        <div className={styles.add_to_cart_div}>
          <button
            onClick={addToCart}
            className={`${styles.add_to_cart_button}`}
          >
            <img
              className={styles.cart_icon}
              src={ShoppingCartIcon}
              alt="cart icon"
            />
            <div className={styles.add_to_cart_text}>Add to Cart</div>
          </button>
        </div>
        <div onClick={changeFavorite} className={styles.favorite_icon_div}>
          <ion-icon
            className={styles.favorite_icon}
            name="heart"
            style={
              currentFavorite
                ? { color: "#ED8787" }
                : { color: "rgba(75, 75, 75, 0.29)" }
            }
          ></ion-icon>
        </div>
      </div>
    </div>
  );
};

export default SingleSubProduct;
